"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.yukumlulukGizleSchema = exports.YUKUMLULUK_GOZDEN_GECIRME_VADESI_AY = exports.yukumlulukGozdenGecirmeSchema = exports.yukumlulukSerhSchema = exports.yukumlulukNotSchema = exports.yukumlulukDurumIsaretSchema = exports.yukumlulukModSchema = exports.yukumlulukIsaretSchema = exports.yukumlulukTakvimSchema = exports.yukumlulukGozdenGecirmeSatiriSchema = exports.yukumlulukTakvimSatiriSchema = exports.yukumlulukKalemOlusturSchema = exports.yukumlulukKalemGuncelleSchema = exports.yukumlulukKalemSchema = exports.yukumlulukKademeSchema = exports.yukumlulukSatirDurumuSchema = exports.YUKUMLULUK_SATIR_DURUMLARI = exports.TEHLIKE_SINIFI_SIRASI = exports.yukumlulukElleDurumSchema = exports.YUKUMLULUK_ELLE_DURUMLARI = exports.yukumlulukKalemModuSchema = exports.YUKUMLULUK_KALEM_MODLARI = exports.yukumlulukTakipDurumuSchema = exports.YUKUMLULUK_TAKIP_DURUMLARI = exports.yukumlulukKademeBirimiSchema = exports.YUKUMLULUK_KADEME_BIRIMLERI = exports.yukumlulukPeriyotBicimiSchema = exports.YUKUMLULUK_PERIYOT_BICIMLERI = exports.yukumlulukKanitTipiSchema = exports.YUKUMLULUK_KANIT_TIPLERI = exports.yukumlulukModuluSchema = exports.YUKUMLULUK_MODULLERI = exports.yukumlulukAltSekliSchema = exports.YUKUMLULUK_ALT_SEKILLERI = exports.yukumlulukTipiSchema = exports.YUKUMLULUK_TIPLERI = exports.yukumlulukKaynagiSchema = exports.YUKUMLULUK_KAYNAKLARI = void 0;
exports.yukumlulukBaglanabilirMi = yukumlulukBaglanabilirMi;
exports.resolveYukumlulukPeriyoduAy = resolveYukumlulukPeriyoduAy;
exports.kalemSinifKapisindanGecerMi = kalemSinifKapisindanGecerMi;
exports.kalemEsikKarsilaniyorMu = kalemEsikKarsilaniyorMu;
exports.kalemIsyerindeDogarMi = kalemIsyerindeDogarMi;
exports.kademeCoz = kademeCoz;
exports.yukumlulukGerekenMiktar = yukumlulukGerekenMiktar;
exports.yukumlulukKalemIhlalleri = yukumlulukKalemIhlalleri;
exports.gozdenGecirmeAyFarki = gozdenGecirmeAyFarki;
exports.gozdenGecirmeVadesiGectiMi = gozdenGecirmeVadesiGectiMi;
exports.isaretSorgulanmaliMi = isaretSorgulanmaliMi;
exports.ucluPeriyot = ucluPeriyot;
const zod_1 = require("zod");
const shared_types_1 = require("@isg/shared-types");
const egitim_1 = require("./egitim");
/**
 * YASAL UYGUNLUK / YÜKÜMLÜLÜK KÜTÜPHANESİ — KURAL KATMANI
 * (F4·S11·B; Kapsam v0.68 §5.16 + §8.2 · ERD v0.55 §10e · CLAUDE.md §2.37 →
 * `.claude/rules/yasal-uygunluk.md`).
 *
 * > **MODÜLÜN TEK CÜMLESİ: YÜKÜMLÜLÜK TEK KÜTÜPHANEDE YAŞAR; KALEMİN TİPİ
 * > DAVRANIŞINI BELİRLER.** Periyodik olan **görev üretir**, sürekli olan
 * > **yokluk taraması üretir**, modül takipli **hiçbir şey üretmez** — yalnız
 * > nereye bakılacağını söyler.
 *
 * ⚠️ **BU DOSYADA YAZILACAK EN KOLAY YANLIŞ KOD: İKİNCİ ÇÖZÜMLEYİCİ.**
 * Periyot `resolveYukumlulukPeriyoduAy`den, kademe `kademeCoz`den, doğum
 * kararı `kalemIsyerindeDogarMi`den okunur. Ekranda ya da uçta "işyerinin
 * sınıfı çok tehlikeliyse..." diye dallanan kod, aynı kuralı ikinci kez
 * tanımlar ve iki tanım zamanla ayrışır (`resolveUyariEsigi` /
 * `resolveEkipmanPeriyoduAy` derslerinin dördüncüsü).
 *
 * ⚠️ **TAKVİM BİR UYGUNLUK BEYANI DEĞİLDİR.** Buradaki hiçbir fonksiyon
 * *"bu işyeri mevzuata uygundur"* demez; **neyin ne zaman gerektiğini** ve
 * **neyin eksik göründüğünü** söyler. Nihai sorumluluk müşterinin İSG
 * profesyonelindedir (Kapsam §8.5).
 */
// ── Kalem kabının eksenleri (ERD §10e) ──────────────────────────────────────
/**
 * ⚠️ **BU BİR KURAL DEĞİL BİR ETİKETTİR** (91-3): *"mevzuat periyodu
 * gevşetilemez"* ifadesinin kod karşılığı **yoktur** — gevşetme serbesttir ve
 * iz mekanizması kurulmadı. Ayrım **raporlama ve okunabilirlik** içindir.
 */
exports.YUKUMLULUK_KAYNAKLARI = ['mevzuat', 'ic_prosedur'];
exports.yukumlulukKaynagiSchema = zod_1.z.enum(exports.YUKUMLULUK_KAYNAKLARI);
/**
 * **İ3 — ÜÇ TİP, ÜÇ DAVRANIŞ.** Çift takip yasağı kütüphanenin varlık
 * şartıdır: aynı yükümlülük iki yerden takip edilirse uzman aynı şeyi iki
 * yerde görür, **birinde kapatır, diğeri açık kalır.**
 */
exports.YUKUMLULUK_TIPLERI = ['periyodik', 'surekli', 'modul_takipli'];
exports.yukumlulukTipiSchema = zod_1.z.enum(exports.YUKUMLULUK_TIPLERI);
/**
 * **YALNIZ `surekli` TİPTE DOLU.**
 *   sayi   — gerekeni hesaplar, mevcudu sayar, **farkı söyler**
 *   sure   — gerekeni hesaplar, **VERİLENİ BİLMEZ** (İ4; İSG-KATİP turunda
 *            tamamlanır — madde 30)
 *   varlik — var mı yok mu
 */
exports.YUKUMLULUK_ALT_SEKILLERI = ['sayi', 'sure', 'varlik'];
exports.yukumlulukAltSekliSchema = zod_1.z.enum(exports.YUKUMLULUK_ALT_SEKILLERI);
/**
 * **YALNIZ `modul_takipli` TİPTE DOLU ve TEK** (İ9). ⚠️ *Tek kalem iki modüle
 * işaret edemez* — B3 (portör muayenesi / hijyen eğitimi) adayının açık
 * sorusu tam budur (tutanak §7.2).
 */
exports.YUKUMLULUK_MODULLERI = ['egitim', 'saglik', 'ekipman', 'risk', 'olay'];
exports.yukumlulukModuluSchema = zod_1.z.enum(exports.YUKUMLULUK_MODULLERI);
/**
 * **TUR 8 / D1 — KANIT BEKLENTİSİ: *"DENETİMDE NE GÖSTERECEĞİM?"***
 * (Kapsam §5.16/13 · ERD §12/36'nın cevabı; ürün sahibi kararı 05.09.2026.)
 *
 * Dört sınıf ve **sorunun sistemdeki karşılığı**:
 *
 *   `belge`        — yüklenen bir DOSYA (sözleşme · plan · ölçüm raporu ·
 *                    sertifika). Kanıt eki (§6b) bu sınıfa asılır.
 *   `form_kaydi`   — doldurulmuş bir FORM (periyodik kalemin görevi kapanınca
 *                    doğan `form_submission`).
 *   `kayit_sayisi` — sistemdeki KAYITLARIN kendisi (görevlendirme · eğitim
 *                    katılımı · kanaat · kontrol) — sayılır, dosya istemez.
 *   `beyan`        — insanın BEYANI; sistemde bir artefakt yoktur (İ5'in elle
 *                    işareti). *Kural motoru yazılmaz* kilidinin kanıt kolu.
 *
 * ⚠️ **`null` "SINIFLANDIRILMADI" DEMEKTİR ve BİR EKSİK DEĞİL, GÖRÜNÜR BİR
 * BOŞLUKTUR** (İ4). Kanıtı bugün sistemde hiçbir şeye karşılık gelmeyen kalem
 * (#31 meslek hastalığı · #33 İBYS eğitim bildirimi) **boş kalır** —
 * *yanlış sınıf yazmaktansa boş* (Yönerge §5, `dayanak`ın kuralıyla aynı).
 * Modülü gelen kalem sınıfını **o gün** kazanır.
 *
 * ⚠️ **BU EKSEN SONRADAN DARALTILAMAZ** (§19/11'in kardeş riski): bir sınıf
 * eklemek kolay, çıkarmak müşterinin doldurduğu satırları bozar. Beşinci sınıf
 * bir ÜRÜN KARARIDIR.
 */
exports.YUKUMLULUK_KANIT_TIPLERI = ['belge', 'form_kaydi', 'kayit_sayisi', 'beyan'];
exports.yukumlulukKanitTipiSchema = zod_1.z.enum(exports.YUKUMLULUK_KANIT_TIPLERI);
/**
 * **YALNIZ `periyodik` TİPTE DOLU.** `bos` = **müşteri doldurur** (İ7 —
 * ortam ölçümleri). ⚠️ **Periyodu girilmemiş kalem SESSİZ BEKLER** (İ8):
 * *sessiz = bildirim üretmez*; kalem işyeri listesinde **periyodu boş olarak
 * GÖRÜNÜR.** Sistem, periyodunu bilmediği kaleme *"uygundur" DEMEZ* — 1 gün
 * marjının ve `sonraki_kontrol` NULL davranışının genellemesi.
 */
exports.YUKUMLULUK_PERIYOT_BICIMLERI = ['sabit', 'tehlike_sinifi', 'bos'];
exports.yukumlulukPeriyotBicimiSchema = zod_1.z.enum(exports.YUKUMLULUK_PERIYOT_BICIMLERI);
/**
 * **KADEME BİRİMİ.**
 *   dakika_calisan_ay        — #4 hekim · #5 uzman · #6 DSP
 *   adet                     — #13 temsilci (mutlak sayı)
 *   bir_kisi_basina_calisan  — #7 ilkyardımcı · #20a-c ekipler (ORAN)
 */
exports.YUKUMLULUK_KADEME_BIRIMLERI = [
    'dakika_calisan_ay',
    'adet',
    'bir_kisi_basina_calisan',
];
exports.yukumlulukKademeBirimiSchema = zod_1.z.enum(exports.YUKUMLULUK_KADEME_BIRIMLERI);
/**
 * **"MODÜL TAKİPLİ" BİR İDDİADIR — KODDA GÖSTERİLMEDEN İŞARETLENMEZ.**
 * S11·B keşif adımının (tutanak §4) kod karşılığı: 13 kalemin her biri için
 * *"o modül gerçekten takip ediyor mu"* sorusu koda bakılarak cevaplandı ve
 * cevap **kalemin üstünde GÖRÜNÜR.**
 *
 * ⚠️ **`takip_edilmiyor` BİR HATA DEĞİL, BİR DÜRÜSTLÜK KAYDIDIR.** Kalemin
 * tipi **DEĞİŞMEZ** (tip değişikliği davranışı değiştirir ve **ürün
 * kararıdır** — sessizce `surekli`ye çevirme yolu YOKTUR); değişen tek şey,
 * kalemin *"şurada takip ediliyor"* yalanını söylememesidir. İ4'ün **görünür
 * boşluk** kuralının modül-takip kolu.
 */
exports.YUKUMLULUK_TAKIP_DURUMLARI = ['takip_ediliyor', 'kismi', 'takip_edilmiyor'];
exports.yukumlulukTakipDurumuSchema = zod_1.z.enum(exports.YUKUMLULUK_TAKIP_DURUMLARI);
// ── TUR 8 / B — İKİ MOD · ŞERH · GÖZDEN GEÇİRME ─────────────────────────────
/**
 * **B1 — KALEMİN İŞYERİNDEKİ MODU.**
 *
 * ⚠️ **VARSAYILAN `elle` ve BU BİLİNÇLİDİR.** Bağlı mod kalemin durumunu modül
 * kayıtlarından türetir; **modül henüz kullanılmıyorken türetme *"uygun
 * değil"* der ve bu YALANDIR** — kayıt yokluğu uygunsuzluk değil,
 * bilgisizliktir (`sonraki_kontrol` NULL davranışının kalem kolu). Gevşek
 * olan varsayılandır; **bağlamak sıkılaştırmadır** ve müşterinin kararıdır.
 *
 * ⚠️ **BAĞLI MODDA ELLE İŞARETLEME KAPANIR (422):** bir kalemin durumunun
 * **iki cevabı olmaz**. İtirazın yolu ŞERHTİR — o türetilen değeri silmez,
 * yanına yazılır ve ikisi de görünür kalır.
 */
exports.YUKUMLULUK_KALEM_MODLARI = ['elle', 'bagli'];
exports.yukumlulukKalemModuSchema = zod_1.z.enum(exports.YUKUMLULUK_KALEM_MODLARI);
/**
 * **B2 — ELLE İŞARETLENEN DURUM.**
 *
 * ⚠️ **`kapsam_disi` BİR ÜÇÜNCÜ DEĞERDİR, *"uygun"*UN EŞ ANLAMLISI DEĞİL:**
 * *"bu işyerinde vinç yok"* ile *"vinç var ve kontrolü yapıldı"* denetimde
 * aynı cümle değildir. Katlamak, kapsam dışı kalemi karşılanmış saydırırdı.
 */
exports.YUKUMLULUK_ELLE_DURUMLARI = ['uygun', 'uygun_degil', 'kapsam_disi'];
exports.yukumlulukElleDurumSchema = zod_1.z.enum(exports.YUKUMLULUK_ELLE_DURUMLARI);
/**
 * **B1 — BU KALEM BAĞLANABİLİR Mİ?** *"Türetilebilir kalem listesi ekranda
 * görünür"* kararının tek yüklemi.
 *
 * ⚠️ **EKRAN İKİNCİ KEZ SORMAZ** (§2.40): düğmenin görünürlüğü ile ucun
 * kapısı **aynı çağrıdan** okunur; iki yerde ayrı yazılan koşul, birine
 * eklenen bir şartın diğerine sessizce eklenmemesiyle *"görünür ama
 * reddeder"* arızasını üretir.
 *
 * ⚠️ **`takip_edilmiyor` BAĞLANAMAZ** ve bu bir dürüstlük kaydıdır (İ4): iddia
 * kodda gösterilemediği sürece kalem *"modülde takip ediliyor"* diyemez.
 */
function yukumlulukBaglanabilirMi(girdi) {
    if (girdi.tip === 'periyodik')
        return true;
    if (girdi.tip === 'modul_takipli')
        return girdi.takipDurumu !== 'takip_edilmiyor';
    if (girdi.tip !== 'surekli')
        return false;
    // SÜREKLİ · SAYI: yalnız SAYILABİLEN kalem türetilir.
    if (girdi.altSekil === 'sayi')
        return girdi.sayilabilir;
    // ✏️ E1 — SÜREKLİ · VARLIK: yalnız ŞART haritasında karşılığı olan kalem
    // türetilir (#23). ⚠️ Haritada olmayanın verisi sistemde YOK ve ona bağlı
    // mod vermek, sistemin bilmediği bir şeye *"uygun değil"* demesi olurdu.
    if (girdi.altSekil === 'varlik')
        return girdi.sartliMi || girdi.varlikKanitiVarMi === true;
    // `sure` (İ4 — İSG-KATİP, madde 30): gerekeni hesaplarız, VERİLENİ bilmeyiz.
    return false;
}
// ── Sıra kilidi ─────────────────────────────────────────────────────────────
/**
 * ⚠️ **ÜÇ DEĞERLİ ALANLARIN SIRASI: `az / tehlikeli / çok`.** C4 artçısının
 * dersi: ürün sahibi kurul periyodunu bir kez **ters sırada** (çok → az)
 * söyledi ve iki ifade **aynı** şeyi anlatıyordu — *sırayı doğrulamadan
 * eşitlik ilan etmek periyodu tersine çevirirdi.*
 *
 * ⚠️ **DİZİLİŞİN YÖNÜ KALEMDEN KALEME AYNI DEĞİLDİR:** periyot kalemlerinde
 * sayı **azalır** (az tehlikelide seyrek: 3/2/1 ay), süre kalemlerinde
 * **artar** (#4: 5/10/15 dk), oran kalemlerinde **azalır** (#7: 20/15/10'da
 * bir). **Sıra sabittir, yön kalemin doğasından gelir** — bu yüzden burada
 * bir "artan/azalan" doğrulaması YOKTUR ve eklenmemelidir.
 */
exports.TEHLIKE_SINIFI_SIRASI = ['az', 'tehlikeli', 'cok'];
/**
 * **PERİYODUN TEK ÇÖZÜMLEYİCİSİ.** Biçim kolonu hangisinin okunacağını söyler
 * ve **okuyucu tektir** — `periyot_ay` ile üç değerli üçlü **bir arada dolu
 * olamaz** (91-1'in iki-taşıyıcı hatasının yükümlülük kolu; DB CHECK son
 * savunma, bu fonksiyon ilk savunma).
 *
 * **FAIL-LOUD:** `bos` biçiminde ve kural eksikse `null` döner — çağıran
 * **varsayılan uydurmaz** (`resolveEkipmanPeriyoduAy` deseni). Birim **AY**
 * (`gecerlilik_ay` §19/11 ve ekipman periyodu 91-1 ile aynı birim; gün/yıl
 * karışımı **ikinci taşıyıcı** demektir).
 */
function resolveYukumlulukPeriyoduAy(kural, tehlikeSinifi) {
    if (kural.periyotBicim === 'sabit') {
        const ay = zod_1.z.number().int().positive().safeParse(kural.periyotAy);
        return ay.success ? ay.data : null;
    }
    if (kural.periyotBicim === 'tehlike_sinifi') {
        const uclu = {
            az: kural.periyotAyAz,
            tehlikeli: kural.periyotAyTehlikeli,
            cok: kural.periyotAyCok,
        }[(0, egitim_1.tehlikeSinifiAnahtari)(tehlikeSinifi)];
        const ay = zod_1.z.number().int().positive().safeParse(uclu);
        return ay.success ? ay.data : null;
    }
    // `bos` (İ7 — müşteri doldurur) ya da periyodik OLMAYAN kalem.
    return null;
}
/** Sınıf sıralaması — "alt sınır" bir EŞİKTİR, eşitlik değil. */
const SINIF_AGIRLIGI = {
    low_risk: 1,
    hazardous: 2,
    highly_hazardous: 3,
};
/**
 * ⚠️ **SINIF KAPISI: KALEM O SINIFTA DOĞMUYORSA İŞYERİNDE HİÇ GÖRÜNMEZ.**
 * Bu, eşik geçişinden **farklı** bir şeydir: eşik geçişinde kalem doğmuştur
 * ve *"koşul kalktı"* hâline inebilir; sınıf kapısı kapalıysa **kalem hiç
 * yoktur** ve tarihçesi de yoktur.
 */
function kalemSinifKapisindanGecerMi(kural, isyeriSinifi) {
    if (!kural.tehlikeSinifiAltSiniri)
        return true;
    return SINIF_AGIRLIGI[isyeriSinifi] >= SINIF_AGIRLIGI[kural.tehlikeSinifiAltSiniri];
}
/**
 * **ÇALIŞAN SAYISI KOŞULU — CANLI.** Sayı `@isg/db workplaceCalisanSayisi`
 * ile her okumada `employment`ten TÜRETİLİR; **sayaç kolonu YOKTUR** (iki
 * kaynak ayrışırsa yanlış yükümlülük üretilir ve kimse fark etmez).
 *
 * Alt sınır ve üst sınır **DAHİLDİR**: #20a-c `≥10`, #20d `≤9` — dört kalem
 * birbirini dışlayan eşiklerle ayrıldı ve **kural motoru gerekmedi.**
 */
function kalemEsikKarsilaniyorMu(kural, calisanSayisi) {
    if (kural.calisanSayisiEsigi != null && calisanSayisi < kural.calisanSayisiEsigi)
        return false;
    if (kural.calisanSayisiEsigiUst != null && calisanSayisi > kural.calisanSayisiEsigiUst)
        return false;
    return true;
}
/**
 * **KALEM BU İŞYERİNDE DOĞAR MI.** İki kapı, **ikisi de aynı anda** geçilmeli.
 * ⚠️ Çağıran, `false` dönen kalemi listeden düşürmeden önce
 * `kalemSinifKapisindanGecerMi`ye ayrıca bakar: **sınıf kapısı kapalı → HİÇ
 * GÖRÜNMEZ; eşik karşılanmıyor → "koşul kalktı" olarak GÖRÜNÜR** (tarihçe
 * kaybolmaz).
 */
function kalemIsyerindeDogarMi(kural, isyeri) {
    return (kalemSinifKapisindanGecerMi(kural, isyeri.tehlikeSinifi) &&
        kalemEsikKarsilaniyorMu(kural, isyeri.calisanSayisi));
}
/**
 * **ÜÇ KALEM SINIFI TEK KOLDAN OKUNUR** (#6 DSP · #13 temsilci ·
 * #7/#20a-c oran). ⚠️ **Üç ayrı özel hal yazılırsa dördüncü şekil dördüncü
 * kod yolunu doğurur** — tek okuyucu ilkesinin kütüphane kolu.
 *
 * Sınıf eşleşmesi: kademenin `tehlikeSinifi`si NULL ise her sınıfa uyar;
 * doluysa **birebir** eşleşir (alt sınır DEĞİL — sınıf ekseni bir eşik değil,
 * bir ayrımdır: #7'de "az tehlikeli" satırı çok tehlikeliye uygulanmaz).
 */
function kademeCoz(kademeler, isyeri) {
    const uyanlar = kademeler.filter((k) => (k.tehlikeSinifi === null || k.tehlikeSinifi === isyeri.tehlikeSinifi) &&
        isyeri.calisanSayisi >= k.altSinir &&
        (k.ustSinir === null || isyeri.calisanSayisi <= k.ustSinir));
    if (uyanlar.length === 0)
        return null;
    // Sınıfa özgü satır, "tüm sınıflar" satırını yener; eşitlikte dar aralık
    // kazanır (üst sınırı olan satır, ∞ satırından özgüldür).
    return [...uyanlar].sort((a, b) => {
        const sinif = Number(b.tehlikeSinifi !== null) - Number(a.tehlikeSinifi !== null);
        if (sinif !== 0)
            return sinif;
        return b.altSinir - a.altSinir;
    })[0];
}
/**
 * **GEREKEN MİKTAR** — kademe satırından + çalışan sayısından.
 *
 *   dakika_calisan_ay       → değer × çalışan   (ayda toplam dakika)
 *   adet                    → değer             (mutlak sayı)
 *   bir_kisi_basina_calisan → katları dâhilse `ceil(çalışan / değer)`,
 *                             değilse 1 (aralık bir BANT'tır, oran değil)
 *
 * ⚠️ **`katlariDahil` OLMADAN ORAN TAVANLANIR.** 300 kişilik işyerinde
 * `50 çalışana kadar 1` kuralı **tek** söndürme elemanı verirdi.
 */
function yukumlulukGerekenMiktar(kademe, calisanSayisi) {
    switch (kademe.birim) {
        case 'dakika_calisan_ay':
            return kademe.deger * calisanSayisi;
        case 'adet':
            return kademe.deger;
        case 'bir_kisi_basina_calisan':
            return kademe.katlariDahil ? Math.ceil(calisanSayisi / kademe.deger) : 1;
    }
}
/**
 * **ÜÇ VERİ KİLİDİ — hepsi *tip ↔ alan* tutarlılığı** (ERD §10e). DB CHECK'i
 * son savunmadır; bu fonksiyon **422** üretir (kural ihlali — 403 değil).
 *
 * ⚠️ **`periyot_ay` ile üç değerli üçlü BİR ARADA DOLU OLAMAZ** — 91-1'in
 * iki-taşıyıcı hatasının yükümlülük kolu.
 */
function yukumlulukKalemIhlalleri(kalem) {
    const ihlaller = [];
    const ucluDolu = [kalem.periyotAyAz, kalem.periyotAyTehlikeli, kalem.periyotAyCok].filter((d) => d != null).length;
    if (kalem.tip === 'surekli' && !kalem.altSekil) {
        ihlaller.push('Sürekli kalem alt şekil taşımalı (sayi | sure | varlik)');
    }
    if (kalem.tip !== 'surekli' && kalem.altSekil) {
        ihlaller.push('Alt şekil YALNIZ sürekli tipte bulunur');
    }
    if (kalem.tip === 'modul_takipli' && !kalem.modul) {
        ihlaller.push('Modül takipli kalem TEK bir modüle işaret etmeli');
    }
    if (kalem.tip !== 'modul_takipli' && kalem.modul) {
        ihlaller.push('Modül alanı YALNIZ modül takipli tipte bulunur');
    }
    if (kalem.tip === 'periyodik' && !kalem.periyotBicim) {
        ihlaller.push('Periyodik kalem periyot biçimi taşımalı (sabit | tehlike_sinifi | bos)');
    }
    if (kalem.tip !== 'periyodik' && kalem.periyotBicim) {
        ihlaller.push('Periyot biçimi YALNIZ periyodik tipte bulunur');
    }
    if (kalem.periyotBicim === 'sabit') {
        if (kalem.periyotAy == null)
            ihlaller.push('Sabit periyotta süre (ay) zorunludur');
        if (ucluDolu > 0) {
            ihlaller.push('Sabit periyotta üç değerli süre yazılmaz — periyodun TEK taşıyıcısı olur');
        }
    }
    if (kalem.periyotBicim === 'tehlike_sinifi') {
        if (ucluDolu !== 3) {
            ihlaller.push('Tehlike sınıfı periyodunda üç değer de (az, tehlikeli, cok) zorunludur');
        }
        if (kalem.periyotAy != null) {
            ihlaller.push('Üç değerli periyotla sabit süre BİR ARADA olamaz (91-1)');
        }
    }
    if (kalem.periyotBicim === 'bos' && (kalem.periyotAy != null || ucluDolu > 0)) {
        ihlaller.push('Boş biçimli periyotta süre alanları NULL kalır (müşteri doldurur — İ7)');
    }
    if (kalem.calisanSayisiEsigi != null &&
        kalem.calisanSayisiEsigiUst != null &&
        kalem.calisanSayisiEsigiUst < kalem.calisanSayisiEsigi) {
        ihlaller.push('Çalışan sayısı üst sınırı alt eşiğin altında olamaz');
    }
    return ihlaller;
}
// ── Takvim satırının durumu (P3 rozet anlamları) ────────────────────────────
/**
 * **TAKVİM SATIRININ DURUMU.** ⚠️ Bu bir **uygunluk beyanı değildir**:
 *   karsilaniyor      — kaydı/görevi var ve vadesi gelmemiş
 *   yaklasiyor        — vadesi uyarı eşiğinde
 *   gecikmis          — vadesi geçmiş ya da gereken sayı karşılanmamış
 *   kayit_yok         — İ4'ün **GÖRÜNÜR BOŞLUĞU**: sistem gerekeni hesapladı,
 *                       **verileni bilmiyor** (hekim/uzman süresi, ekip
 *                       sayıları). *Görünür boşluk, çalışıyor sanılan
 *                       boşluktan iyidir.*
 *   periyot_bekliyor  — İ8: müşteri periyodu doldurmadı → **SESSİZ BEKLER**
 *                       (bildirim üretmez, listede GÖRÜNÜR)
 *   kosul_kalkti      — eşik altına düştü (49→50→49). **Kalem DÜŞMEZ**;
 *                       tarihçe kaybolmasın diye bu hâle iner.
 *   takip_edilmiyor   — modül-takip iddiası **kodda gösterilemedi**
 *                       (dürüstlük kaydı; tip DEĞİŞMEZ — ürün kararı)
 *   modulde           — modül takipli ve modülü gerçekten takip ediyor
 */
exports.YUKUMLULUK_SATIR_DURUMLARI = [
    'karsilaniyor',
    'yaklasiyor',
    'gecikmis',
    'kayit_yok',
    'periyot_bekliyor',
    'kosul_kalkti',
    'takip_edilmiyor',
    'modulde',
];
exports.yukumlulukSatirDurumuSchema = zod_1.z.enum(exports.YUKUMLULUK_SATIR_DURUMLARI);
// ── API şemaları ────────────────────────────────────────────────────────────
exports.yukumlulukKademeSchema = zod_1.z.strictObject({
    tehlikeSinifi: zod_1.z.enum(['low_risk', 'hazardous', 'highly_hazardous']).nullable(),
    altSinir: zod_1.z.number().int().nonnegative(),
    ustSinir: zod_1.z.number().int().positive().nullable(),
    deger: zod_1.z.number().positive(),
    birim: exports.yukumlulukKademeBirimiSchema,
    katlariDahil: zod_1.z.boolean(),
});
/** Kütüphane nüshasının okuma yüzeyi (yapılandırma listesi). */
exports.yukumlulukKalemSchema = zod_1.z.strictObject({
    id: zod_1.z.uuid(),
    kutuphaneRef: zod_1.z.uuid().nullable(),
    ad: zod_1.z.string().min(1),
    kaynak: exports.yukumlulukKaynagiSchema,
    dayanak: zod_1.z.string().nullable(),
    tip: exports.yukumlulukTipiSchema,
    altSekil: exports.yukumlulukAltSekliSchema.nullable(),
    modul: exports.yukumlulukModuluSchema.nullable(),
    periyotBicim: exports.yukumlulukPeriyotBicimiSchema.nullable(),
    periyotAy: zod_1.z.number().int().positive().nullable(),
    periyotAyAz: zod_1.z.number().int().positive().nullable(),
    periyotAyTehlikeli: zod_1.z.number().int().positive().nullable(),
    periyotAyCok: zod_1.z.number().int().positive().nullable(),
    calisanSayisiEsigi: zod_1.z.number().int().positive().nullable(),
    calisanSayisiEsigiUst: zod_1.z.number().int().positive().nullable(),
    tehlikeSinifiAltSiniri: zod_1.z.enum(['low_risk', 'hazardous', 'highly_hazardous']).nullable(),
    nitelikAz: zod_1.z.string().nullable(),
    nitelikTehlikeli: zod_1.z.string().nullable(),
    nitelikCok: zod_1.z.string().nullable(),
    /**
     * ⚠️ **TUR 8 / H1 — BU ALAN ON GÜN BOYUNCA ŞEMADA YOKTU ve uç HER
     * ÇAĞRIDA 500 VERİYORDU.** `strictObject` tanımadığı anahtarı reddeder;
     * `listObligationItems` bu kolonu her satırda döndürüyordu. Arıza
     * görünmedi çünkü **ucu çağıran hiçbir ekran yoktu** (C2'nin yokluğu) —
     * *"uç var" cümlesi "yol var" cümlesi değildir* (Yönerge §6/7; h-3'ün
     * `POST lookup/:listeKodu` vakasının kardeşi). Kanıt artık
     * `obligation.spec`'in sözleşme testindedir: gerçek satır bu şemadan
     * geçer.
     */
    varsayilanSorumluSapka: zod_1.z.enum(shared_types_1.ROLE_TYPES).nullable(),
    kanitTipi: exports.yukumlulukKanitTipiSchema.nullable(),
    kanitMetni: zod_1.z.string().nullable(),
    elleIsaretMetni: zod_1.z.string().nullable(),
    kademeKaynakRef: zod_1.z.uuid().nullable(),
    gizli: zod_1.z.boolean(),
    kademeler: zod_1.z.array(exports.yukumlulukKademeSchema),
    /** Modül-takip iddiasının KOD karşılığı; modül takipli olmayanda null. */
    takipDurumu: exports.yukumlulukTakipDurumuSchema.nullable(),
});
/**
 * ⚠️ **KİMLİK KİLİDİ (§19/9 aynen):** `kutuphane_ref` DOLU satırda `ad` ve
 * `dayanak` **üründen gelir** — bu şemada YOKTUR ve uç 422 verir. Serbest
 * olan **kural alanlarıdır** (91-2'nin yükümlülük kolu: *kütüphane önerir,
 * müşteri belirler*). Müşterinin kendi kaleminde her şey serbesttir.
 */
exports.yukumlulukKalemGuncelleSchema = zod_1.z
    .object({
    periyotBicim: exports.yukumlulukPeriyotBicimiSchema.nullable().optional(),
    periyotAy: zod_1.z.number().int().positive().nullable().optional(),
    periyotAyAz: zod_1.z.number().int().positive().nullable().optional(),
    periyotAyTehlikeli: zod_1.z.number().int().positive().nullable().optional(),
    periyotAyCok: zod_1.z.number().int().positive().nullable().optional(),
    calisanSayisiEsigi: zod_1.z.number().int().positive().nullable().optional(),
    calisanSayisiEsigiUst: zod_1.z.number().int().positive().nullable().optional(),
    /** D1 — kanıt beklentisi de bir KURAL alanıdır: müşteri daraltabilir. */
    kanitTipi: exports.yukumlulukKanitTipiSchema.nullable().optional(),
    kanitMetni: zod_1.z.string().max(500).nullable().optional(),
    /** C2 — sorumlu şapka önerisi; kütüphane BOŞ iner, müşteri belirler. */
    varsayilanSorumluSapka: zod_1.z.enum(shared_types_1.ROLE_TYPES).nullable().optional(),
})
    .strict();
/**
 * **C3 — MÜŞTERİNİN KENDİ KALEMİ.**
 *
 * ⚠️ **KAYNAK `ic_prosedur`DUR ve SEÇTİRİLMEZ.** *"Mevzuat"* etiketi ürünün
 * verdiği kalemlerin işaretidir; müşterinin açtığı satıra onu yazdırmak,
 * kütüphanenin **kimin sözü olduğu** bilgisini yok ederdi (§19/9'un kimlik
 * kilidiyle aynı aile — orada `ad` korunuyordu, burada `kaynak`).
 *
 * ⚠️ **`kutuphane_ref` NULL DOĞAR** → kalem müşterinindir: `ad` · `dayanak`
 * dahil **her şeyi serbestçe düzenler** (§19/9'un ikinci yarısı) ve
 * **dağıtım onu EZMEZ** (insert-only).
 *
 * ⚠️ **TİP DAVRANIŞI BELİRLER** — `periyodik` kalem görev üretir, `surekli`
 * tarama üretir. **`modul_takipli` MÜŞTERİYE KAPALIDIR (422):** o tip *"şu
 * modül takip ediyor"* diye bir **İDDİADIR** ve iddiayı doğru kılan şey
 * `YUKUMLULUK_MODUL_TAKIP_HARITASI`'ndaki **kod kanıtıdır** — müşteri kendi
 * kalemine kanıt yazamaz, dolayısıyla o tipi de seçemez.
 */
exports.yukumlulukKalemOlusturSchema = zod_1.z
    .strictObject({
    ad: zod_1.z.string().trim().min(1).max(200),
    dayanak: zod_1.z.string().trim().max(300).nullable().optional(),
    tip: zod_1.z.enum(['periyodik', 'surekli']),
    altSekil: exports.yukumlulukAltSekliSchema.nullable().optional(),
    periyotBicim: exports.yukumlulukPeriyotBicimiSchema.nullable().optional(),
    periyotAy: zod_1.z.number().int().positive().nullable().optional(),
    periyotAyAz: zod_1.z.number().int().positive().nullable().optional(),
    periyotAyTehlikeli: zod_1.z.number().int().positive().nullable().optional(),
    periyotAyCok: zod_1.z.number().int().positive().nullable().optional(),
    calisanSayisiEsigi: zod_1.z.number().int().positive().nullable().optional(),
    calisanSayisiEsigiUst: zod_1.z.number().int().positive().nullable().optional(),
    tehlikeSinifiAltSiniri: zod_1.z
        .enum(['low_risk', 'hazardous', 'highly_hazardous'])
        .nullable()
        .optional(),
    kanitTipi: exports.yukumlulukKanitTipiSchema.nullable().optional(),
    kanitMetni: zod_1.z.string().max(500).nullable().optional(),
    varsayilanSorumluSapka: zod_1.z.enum(shared_types_1.ROLE_TYPES).nullable().optional(),
})
    .superRefine((deger, ctx) => {
    // ⚠️ TİP ↔ ALAN TUTARLILIĞI BURADA DA KOŞAR: `yukumlulukKalemIhlalleri`
    // son savunmadır (uçta), bu ise girdinin kendi kilididir.
    if (deger.tip === 'surekli' && !deger.altSekil) {
        ctx.addIssue({ code: 'custom', message: 'Sürekli kalem bir alt şekil taşımalı' });
    }
    if (deger.tip === 'periyodik' && deger.altSekil) {
        ctx.addIssue({ code: 'custom', message: 'Periyodik kalem alt şekil taşımaz' });
    }
});
/** Takvim satırı — TÜRETİLİR, hiçbir sonuç kolonundan okunmaz. */
exports.yukumlulukTakvimSatiriSchema = zod_1.z.strictObject({
    kalemId: zod_1.z.uuid(),
    ad: zod_1.z.string().min(1),
    kaynak: exports.yukumlulukKaynagiSchema,
    dayanak: zod_1.z.string().nullable(),
    tip: exports.yukumlulukTipiSchema,
    altSekil: exports.yukumlulukAltSekliSchema.nullable(),
    modul: exports.yukumlulukModuluSchema.nullable(),
    durum: exports.yukumlulukSatirDurumuSchema,
    /** Çözümlenmiş periyot (AY); `bos` biçimde null (İ8 — sessiz bekler). */
    periyotAy: zod_1.z.number().int().positive().nullable(),
    /** Kademeden hesaplanan gereken miktar; kademesiz kalemde null. */
    gereken: zod_1.z.number().nullable(),
    gerekenBirim: exports.yukumlulukKademeBirimiSchema.nullable(),
    /**
     * ✏️ **TUR 8 / A2 — ÜÇ SAYI: GEREKEN · GÖREVLENDİRİLMİŞ · YETERLİ.**
     * ~~`mevcut`~~ tek sayısı kaldırıldı: *"kaç kişi var"* sorusunun iki
     * cevabı vardır ve ikisi de gerçektir — kaç kişiye görev VERİLMİŞ, ve o
     * kişilerden kaçı görevin ŞARTLARINI taşıyor. Ekran *"3 gerekli · 3
     * görevlendirilmiş · 1'i sertifikasız"* diyebilsin diye ikisi de iner.
     *
     * ⚠️ **`null` = "KAYIT YOK"** — sıfır DEĞİL. İ4: sistem gerekeni hesaplar,
     * verileni bilmez; ekranda **boşluk olarak söylenir.** Sayılabilen kalemde
     * (sayım haritasında karşılığı olan) değer **0 olabilir** ve bu bir
     * boşluk değil bir **sıfırdır**: tür duruyor, kimse görevlendirilmemiş.
     */
    gorevlendirilmis: zod_1.z.number().int().nonnegative().nullable(),
    /** Görevlendirilmişlerden **şartları tam** olanlar (damgasızlar). */
    yeterli: zod_1.z.number().int().nonnegative().nullable(),
    /** #5'in NİTELİK KAPISI (A/B/C) — bir periyot ya da miktar DEĞİLDİR. */
    nitelik: zod_1.z.string().nullable(),
    /** D1 — denetimde ne gösterilecek; `null` = sınıflandırılmadı (görünür boşluk). */
    kanitTipi: exports.yukumlulukKanitTipiSchema.nullable(),
    kanitMetni: zod_1.z.string().nullable(),
    /**
     * **D2 — KANIT EKLERİ.** ⚠️ **GENEL KONTEYNER** (`stored_file.konteyner`
     * varsayılanı) — yükümlülük kanıtı bir SAĞLIK verisi değildir ve sağlık
     * konteynerine asılmaz (§2.3'ün sınırı ters yönden de geçerlidir: sağlık
     * dışı veriyi oraya koymak, o konteynerin *"yalnız sağlık"* sözleşmesini
     * bozar). Ek `belge` sınıfı kalemlerde beklenir; başka sınıfta da
     * yüklenebilir — kanıt sınıfı bir **beklenti**dir, bir kapı değil.
     */
    ekler: zod_1.z.array(zod_1.z.strictObject({
        id: zod_1.z.uuid(),
        dosyaAdi: zod_1.z.string(),
        boyut: zod_1.z.number().int().nonnegative(),
        yukleyenAd: zod_1.z.string().nullable(),
        yuklemeTarihi: zod_1.z.iso.date(),
    })),
    elleIsaretMetni: zod_1.z.string().nullable(),
    elleIsaret: zod_1.z.boolean(),
    /** İ5 — işaret konulmamış ve faaliyet başlangıcından 6 ay geçmiş. */
    isaretSorgulanmali: zod_1.z.boolean(),
    takipDurumu: exports.yukumlulukTakipDurumuSchema.nullable(),
    /**
     * ✏️ **TUR 8 / F3 — `takipKaniti` YANITTAN DÜŞTÜ.** İçeriği kullanıcının
     * açıp okuyamayacağı **iç kod adlarıydı** (`deriveYetkinlikBitis` ·
     * `person_competency.gecerlilik_bitis` · `resolveEkipmanPeriyoduAy`) ve
     * hiçbir tüketicisi yoktu — ağdan inen bir yanıt da ayrımı taşımaz
     * (madde 37 dersi; §2.40'ın **iç dil** kolu). **Kanıt metni KODDA
     * KALDI** (`YUKUMLULUK_MODUL_TAKIP_HARITASI` — envanter testi boş
     * bırakılmasına hâlâ izin vermez): o metin *geliştiriciye* iddianın
     * nerede gösterildiğini söyler, kullanıcıya değil.
     *
     * Kullanıcının duyduğu cümle `takipNotu`dur ve **D2 dilindedir**: *ne
     * eksik olduğunu* söyler, *hangi fonksiyonda* olduğunu değil.
     */
    takipNotu: zod_1.z.string().nullable(),
    /** Periyodik kalemin beşinci motordaki karşılığı; yoksa null. */
    gorevAtamaId: zod_1.z.uuid().nullable(),
    sonrakiVade: zod_1.z.iso.date().nullable(),
    // ── TUR 8 / B — MOD · ELLE İŞARET · ŞERH ─────────────────────────────────
    /** B1 — kalemin bu işyerindeki modu (varsayılan `elle`). */
    mod: exports.yukumlulukKalemModuSchema,
    /**
     * B1 — kalem BAĞLANABİLİR mi (sistem durumunu türetebilir mi).
     * ⚠️ Ekran düğmeyi buna göre çizer; **uç da aynı yüklemi çağırır** — iki
     * yerde ayrı yazılan koşul *"görünür ama reddeder"* arızasını üretir.
     */
    baglanabilir: zod_1.z.boolean(),
    /** B1/E2 — bağlanamıyorsa NEDEN (kullanıcı diliyle; boş bırakılabilir). */
    baglanamamaSebebi: zod_1.z.string().nullable(),
    /** B2 — elle moddaki durum işareti; bağlı modda NULL. */
    elleDurum: exports.yukumlulukElleDurumSchema.nullable(),
    /**
     * ✏️ GEZİNTİ ARTÇISI 2 / B4.2 — `elleGerekce` → `notu`. Serbest metin
     * açıklama; zorunlu DEĞİL ve MODDAN BAĞIMSIZ (bağlı modda da görünür).
     * ⚠️ Şerhin gerekçesiyle (`serh.gerekce`) KARIŞTIRILMAZ.
     */
    notu: zod_1.z.string().nullable(),
    isaretleyenAd: zod_1.z.string().nullable(),
    isaretTarihi: zod_1.z.iso.date().nullable(),
    /**
     * B3 — YÜRÜRLÜKTEKİ ŞERH (itiraz). ⚠️ **Türetilen `durum` alanını EZMEZ:**
     * ikisi de görünür kalır, denetimde iz budur. Gözden geçirmede DÜŞER.
     */
    serh: zod_1.z
        .strictObject({
        id: zod_1.z.uuid(),
        durum: exports.yukumlulukElleDurumSchema,
        gerekce: zod_1.z.string().min(1),
        koyanAd: zod_1.z.string().nullable(),
        tarih: zod_1.z.iso.date(),
    })
        .nullable(),
});
/**
 * **B4 — GÖZDEN GEÇİRME KAYDI.** *"Bu değerlendirmeye en son ne zaman
 * bakıldı?"* ⚠️ Bir uygunluk sonucu DEĞİL, bir **bakma kaydıdır**; takvim
 * yine her okumada türetilir.
 */
exports.yukumlulukGozdenGecirmeSatiriSchema = zod_1.z.strictObject({
    id: zod_1.z.uuid(),
    tarih: zod_1.z.iso.date(),
    yapanAd: zod_1.z.string().nullable(),
    aciklama: zod_1.z.string().nullable(),
    /** Bu gözden geçirmenin DÜŞÜRDÜĞÜ şerh sayısı (B3). */
    dusenSerhSayisi: zod_1.z.number().int().nonnegative(),
});
exports.yukumlulukTakvimSchema = zod_1.z.strictObject({
    workplaceId: zod_1.z.uuid(),
    workplaceAd: zod_1.z.string().min(1),
    companyAd: zod_1.z.string().min(1),
    tehlikeSinifi: zod_1.z.enum(['low_risk', 'hazardous', 'highly_hazardous']),
    calisanSayisi: zod_1.z.number().int().nonnegative(),
    satirlar: zod_1.z.array(exports.yukumlulukTakvimSatiriSchema),
    /** B4 — en son gözden geçirme; hiç yapılmadıysa null. */
    sonGozdenGecirme: exports.yukumlulukGozdenGecirmeSatiriSchema.nullable(),
    /**
     * B4 — son gözden geçirmenin üstünden geçen AY; hiç yapılmadıysa null.
     * ⚠️ **Vade kararı SUNUCUDA:** ekran *"12'den büyük mü"* diye dallanmaz
     * (ikinci kural yazmak olurdu) — `gozdenGecirmeVadesiGecti`yi okur.
     */
    gozdenGecirmeAyFarki: zod_1.z.number().int().nonnegative().nullable(),
    gozdenGecirmeVadesiGecti: zod_1.z.boolean(),
});
exports.yukumlulukIsaretSchema = zod_1.z.strictObject({ elleIsaret: zod_1.z.boolean() });
// ── TUR 8 / B — YAZMA GİRDİLERİ ─────────────────────────────────────────────
/** B1 — kalemi işyerinde `elle` ↔ `bagli` moda alma. */
exports.yukumlulukModSchema = zod_1.z.strictObject({ mod: exports.yukumlulukKalemModuSchema });
/**
 * B2 — ELLE DURUM İŞARETİ.
 *
 * ~~⚠️ **GEREKÇE `uygun_degil` ve `kapsam_disi`DE ZORUNLUDUR.**~~
 * ✏️ **GEZİNTİ ARTÇISI 2 / B4.2 (ürün sahibi 07.09.2026): GEREKÇE ALANI
 * KALKTI.** Durumun gerekçesini **kanıt belgesi** taşır; açıklama ayrı uçtan
 * yazılan **not**tadır (`yukumlulukNotSchema`). Şema `strictObject`tir:
 * gövdede `gerekce` gönderen eski istemci **400** alır — sessizce yutulan bir
 * alan, kullanıcıya *"yazdım, kaydedildi"* dedirtirdi.
 */
exports.yukumlulukDurumIsaretSchema = zod_1.z.strictObject({
    durum: exports.yukumlulukElleDurumSchema.nullable(),
});
/**
 * ✏️ **GEZİNTİ ARTÇISI 2 / B4.2 — NOT (serbest metin, zorunlu DEĞİL).**
 * Boş metin notu KALDIRIR (sunucu `null`a indirir). ⚠️ Moddan bağımsızdır:
 * bağlı modda da yazılır ve bağlı moda geçiş onu silmez.
 */
exports.yukumlulukNotSchema = zod_1.z.strictObject({
    notu: zod_1.z.string().max(2000).nullable(),
});
/**
 * B3 — ŞERH (itiraz). ⚠️ Gerekçe **her zaman** zorunludur: şerh, sistemin
 * hesabına karşı konan bir iddiadır ve gerekçesizi denetimde savunulamaz.
 */
exports.yukumlulukSerhSchema = zod_1.z.strictObject({
    durum: exports.yukumlulukElleDurumSchema,
    gerekce: zod_1.z.string().trim().min(1).max(2000),
});
/**
 * B4 — GÖZDEN GEÇİRME. Kapanışı o dönemin şerhlerini **düşürür** — şerh
 * kalıcı bir sonuç değil **dönemlik bir beyandır**.
 */
exports.yukumlulukGozdenGecirmeSchema = zod_1.z.strictObject({
    tarih: zod_1.z.iso.date(),
    aciklama: zod_1.z.string().trim().max(4000).nullable().optional(),
});
/**
 * **B4 — YILLIK VADE.** Gözden geçirme yılda bir beklenir; *"değerlendirmen
 * N aydır güncellenmedi"* bildirimi bunun üstünde koşar (F1).
 * ⚠️ **TEK SABİT** — ekran, bildirim ve rapor onu buradan okur.
 */
exports.YUKUMLULUK_GOZDEN_GECIRME_VADESI_AY = 12;
/** Ay farkı — gün hassasiyetli, saate ÇEVRİLMEZ (`tarihGoster` ailesi). */
function gozdenGecirmeAyFarki(sonTarih, bugun) {
    if (!sonTarih)
        return null;
    const ay = (bugun.getUTCFullYear() - sonTarih.getUTCFullYear()) * 12 +
        (bugun.getUTCMonth() - sonTarih.getUTCMonth());
    return Math.max(0, bugun.getUTCDate() < sonTarih.getUTCDate() ? ay - 1 : ay);
}
/**
 * ⚠️ **HİÇ GÖZDEN GEÇİRİLMEMİŞ İŞYERİ VADESİ GEÇMİŞ SAYILMAZ.** Sistem
 * kurulduğu gün her işyerini kırmızı yakmak, göstergeyi ilk gün anlamsız
 * kılardı (alarm körlüğü); vade **ilk gözden geçirmeden sonra** işler.
 */
function gozdenGecirmeVadesiGectiMi(ayFarki) {
    return ayFarki !== null && ayFarki >= exports.YUKUMLULUK_GOZDEN_GECIRME_VADESI_AY;
}
/** §19/9 — nüsha SİLİNMEZ, GİZLENİR. Ayrı uç, ayrı şapka (holding). */
exports.yukumlulukGizleSchema = zod_1.z.strictObject({ gizli: zod_1.z.boolean() });
/**
 * **İ5 — ALTI AY DOLUNCA SORGULANIR, ENGELLENMEZ.** *"Kısa süreli işyeri"*
 * işareti konur ve unutulur: şantiye kısa süreli açılır, iş uzar, **iki yıl
 * kurulsuz çalışılır.** Faaliyet başlangıcı künyede zaten var; sorgulamak
 * ucuz. **Karar yine sahada** — bu fonksiyon bir engel üretmez, bir soru
 * üretir.
 */
function isaretSorgulanmaliMi(elleIsaret, faaliyetBaslangic, bugun) {
    if (!elleIsaret || !faaliyetBaslangic)
        return false;
    const altiAySonra = new Date(faaliyetBaslangic);
    altiAySonra.setUTCMonth(altiAySonra.getUTCMonth() + 6);
    return bugun >= altiAySonra;
}
/** Üç değerli haritayı kalem kolonlarına açar (içerik dosyasının yardımcısı). */
function ucluPeriyot(harita) {
    return {
        periyotAyAz: harita.az,
        periyotAyTehlikeli: harita.tehlikeli,
        periyotAyCok: harita.cok,
    };
}
//# sourceMappingURL=yukumluluk.js.map